import { render, staticRenderFns } from "./CustomerGroupCustomers.vue?vue&type=template&id=3146d62e&"
import script from "./CustomerGroupCustomers.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports